module.exports = __webpack_public_path__ + "img/event_vailable.933e7870.svg";